
import React, { useLayoutEffect, useRef } from 'react'
import { Link } from 'gatsby'
import { useApplicationContext } from '../provider'
import {Helmet} from 'react-helmet';

export default function Pages() {
    const { Cookies } = useApplicationContext()

    const homeRef = useRef(null)
    const classichomeRef = useRef(null)

    useLayoutEffect(() => {
      let val =
        window && window.__INITIALDATA__ && window.__INITIALDATA__.uiramp

      let origin =
        typeof window !== `undefined` &&
        window.__INITIALDATA__ &&
        window.__INITIALDATA__.isPaypal
      localStorage.setItem('origin', origin)

      if (!Cookies.get('ppcp_ramp', { path: '/' })) {
        if (val === 'Trmt_Developer_New_IA') {
          Cookies.set('ppcp_ramp', 'newia', { path: '/' })
        } else {
          Cookies.set('ppcp_ramp', 'oldia', { path: '/' })
        }
      }
      return homeRef.current.click()
    }, [Cookies])
    return (
        <>
            <Helmet>
              <meta name="google-site-verification" content="08AuxOFMudC-SlG1OO2LsJ6r9YjQhylNJ8gJnOQNV5M" />
            </Helmet>
            <Link ref={homeRef} to="/home" />
        </>
    )
}
